import { render, staticRenderFns } from "./DataCategory.vue?vue&type=template&id=852cf52c"
import script from "./DataCategory.vue?vue&type=script&lang=js"
export * from "./DataCategory.vue?vue&type=script&lang=js"
import style0 from "./DataCategory.vue?vue&type=style&index=0&id=852cf52c&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports